import React from "react";
import { Route, Routes } from "react-router";
import { useAuthorization } from "@common/providers";
import { useV2GetProjectByIdQuery } from "@generated";
import usePrivilegeCheck from "@common/hooks/usePrivilegeCheck";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import useListContacts from "./api/useListContacts";
import useListContactProjectVariables from "./api/useListContactProjectVariables";
import Show from "./Show/Show";
import Edit from "./Edit/Edit";
import New from "./New/New";

interface Props {
  project_id: string;
}

const ProjectContactsV2Mspa: React.FC<Props> = ({ project_id }) => {
  const projectId = project_id;
  const { data: project, isLoading: projectLoading } = useV2GetProjectByIdQuery({
    id: String(projectId),
    include: ["client"],
  });

  const { accessLevel, privilegesLoading, user } = usePrivilegeCheck();

  const { contacts, contactsLoading } = useListContacts({ projectId });

  const { variables, variablesLoading } = useListContactProjectVariables();

  const authorized = useAuthorization();

  if (
    !authorized ||
    projectLoading ||
    privilegesLoading ||
    contactsLoading ||
    variablesLoading ||
    !project ||
    !user
  ) {
    return <ScopeStackSpinner />;
  }

  const projectStatus = project?.data?.attributes?.status || "";
  const permission = accessLevel("projects.contacts") || "view";

  const clientRelationship = project?.data?.relationships?.client?.data;
  const clientId = clientRelationship
    ? String((clientRelationship as any).id)
    : null;

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Show
            projectId={projectId}
            projectStatus={projectStatus}
            permission={permission}
          />
        }
      />
      <Route
        path="/edit/:contactId"
        element={
          <Edit
            projectId={projectId}
            permission={permission}
            projectStatus={projectStatus}
            contacts={contacts}
            clientId={clientId}
            projectVariableDefinitions={variables}
          />
        }
      />
      <Route
        path="/new"
        element={
          <New
            projectId={projectId}
            permission={permission}
            projectStatus={projectStatus}
            contacts={contacts}
            clientId={clientId}
            projectVariableDefinitions={variables}
          />
        }
      />
    </Routes>
  );
};

export default ProjectContactsV2Mspa;
